import * as v from '@badrap/valita'
import decode, { JwtPayload } from 'jwt-decode'
import { api } from 'src/api'
import { encrypt } from 'src/utils/crypto'
import { savedTokens } from './storage'
import { Region } from 'src/regions'
import { savedBackendRegion } from 'src/storage'
import { toast } from 'sonner'

export async function getTokenForCode(code: string, backendRegion: Region) {
  const tokens = await api({
    schema: v
      .object({
        result: v.literal('OK'),
        token: v.object({
          id_token: v.string(),
          access_token: v.string(),
          refresh_token: v.string(),
          expires_in: v.number(),
          token_type: v.literal('Bearer'),
        }),
      })
      .chain((data) => v.ok(data.token)),
    method: 'POST',
    url: '/gettokenforcode',
    body: {
      code,
      check: encrypt(code),
      organization: code,
      redirecturl: window.location.origin,
    },
    withAuth: false,
    region: backendRegion,
  })

  const decodedToken = decode<
    JwtPayload & {
      'cognito:username'?: string
      'custom:organization'?: string
      'custom:region'?: Region
    }
  >(tokens.id_token)
  const username = decodedToken['cognito:username']
  const organization = decodedToken['custom:organization']
  const region = decodedToken['custom:region'] || 'eu-central-1'

  if (!username || !organization) {
    const errorMessage =
      'token is not valid: missing cognito:username or custom:organization'
    console.warn(errorMessage)
    throw new Error(errorMessage)
  }

  savedBackendRegion.set(region)
  savedTokens.set({
    username,
    organization,
    region,
    idToken: tokens.id_token,
    accessToken: tokens.access_token,
    expires: tokens.expires_in * 1000 + Date.now(),
    refreshToken: tokens.refresh_token,
  })

  return Promise.resolve({ ...tokens, username, organization })
}

export async function getRefreshToken(
  oldTokens: Exclude<ReturnType<(typeof savedTokens)['get']>, null>,
) {
  const tokens = await api({
    schema: v
      .object({
        result: v.literal('OK'),
        token: v.object({
          id_token: v.string(),
          access_token: v.string(),
          expires_in: v.number(),
          token_type: v.literal('Bearer'),
        }),
      })
      .chain((data) => v.ok(data.token)),
    url: '/getrefreshfortoken',
    method: 'POST',
    body: {
      check: encrypt(oldTokens.organization),
      organization: oldTokens.organization,
      redirecturl: window.location.origin,
      refresh_token: oldTokens.refreshToken,
    },
    withAuth: false,
  }).catch((error) => {
    savedTokens.clear()
    toast.warning(
      'An error occurred while trying to refresh token, you need to login again',
    )
    return Promise.reject(error)
  })

  savedTokens.set({
    ...oldTokens,
    expires: tokens.expires_in * 1000 + Date.now(),
    accessToken: tokens.access_token,
    idToken: tokens.id_token,
  })
}
